/***
 *
 *   SUPER ADMIN LAYOUT
 *   Minimal standalone shell for the super-admin area — no normal user
 *   sidebar. Top bar with a "Super Admin" label, a back-to-portal link,
 *   and the user menu.
 *
 *   PROPS
 *   children: passed from router > view > here (component(s), required)
 *   title: title of the view for the header (string, required)
 *
 **********/

import { Fragment } from "react";
import { User, useNavigate, useTranslation } from "components/lib";

export function SuperAdminLayout({ title, children }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Fragment>
      {/* Portal background with glassmorphism */}
      <div className="fixed inset-0 portal-gradient portal-dots-pattern">
        <div className="absolute inset-0 portal-gradient-overlay"></div>
        <div className="absolute inset-0 portal-mesh-pattern opacity-30"></div>
      </div>

      <main className="relative z-10 min-h-screen px-4 sm:px-8 pt-4 pb-8 fade-in">
        {/* Top bar */}
        <header className="flex items-center justify-between gap-4 py-4 mb-4 border-b border-white/10">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-2 text-white poppins-semibold text-lg">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2l8 3v6c0 5-3.5 8.5-8 11-4.5-2.5-8-6-8-11V5l8-3z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
              </svg>
              Super Admin
            </span>
            <button
              type="button"
              onClick={() => navigate("/dashboard")}
              className="text-sm text-white/60 hover:text-white/90 poppins-light transition-colors duration-300"
            >
              ← {t("nav.dashboard") || "Back to portal"}
            </button>
          </div>

          <User />
        </header>

        <div className="slide-up" style={{ animationDelay: "0.1s" }}>
          {children}
        </div>
      </main>
    </Fragment>
  );
}
